<template>
  <div class="main-footer">
    <div class="container" style="margin: 0px; box-sizing: border-box; font-size: 16px;">
      <div class="footer-container row footer-info">
        <div class="col-12 footer-info-container">
          <h5 class="title mt-3 mt-lg-0">{{ $filters.translate('T_OTHER_INFORMATION') }}</h5>
          <div>
            <ul>
              <li>
                <a href="http://aao.hkbu.edu.hk/en/home/index.php" target="_blank" class="footer-link">
                  {{ $filters.translate('T_ALUMNI') }}
                </a>
              </li>
              <li>
                <a href="https://cmc.hkbu.edu.hk/" target="_blank" class="footer-link">
                  {{ $filters.translate('T_CHINESE_MEDICINE_CLINICS') }}
                </a>
              </li>
              <li>
                <a href="https://foundation.hkbu.edu.hk/en/ways-to-give" target="_blank" class="footer-link">
                  {{ $filters.translate('T_GIVING_TO_HKBU') }}
                </a>
              </li>
              <li>
                <a href="https://library.hkbu.edu.hk/" target="_blank" class="footer-link">
                  {{ $filters.translate('T_LIBRARY') }}
                </a>
              </li>
              <li>
                <a href="https://hkbu-sustainability.hkbu.edu.hk/" target="_blank" class="footer-link">
                  {{ $filters.translate('T_SUSTAINABILITY') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 footer-info-container">
          <h5 class="title mt-3 mt-lg-0">
            {{ $filters.translate('T_ENQUIRIES') }}
          </h5>
          <table class="table table-sm table-borderless">
            <tbody>
              <tr>
                <td colspan="2">
                  <a href="https://www.hkbu.edu.hk/en/contact.html" class="footer-link-contactus">
                    {{ $filters.translate('T_CONTACT_US') }}
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $filters.translate('T_TEL') }}:
                </td>
                <th>(852) 3411 7400</th>
              </tr> <tr>
                <td>
                  {{ $filters.translate('T_ADDRESS') }}:
                </td>
                <th>
                  <p v-html="$filters.translate('T_ADDRESS_LINES')" />
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 footer-info-container footer-social-container">
          <h5 class="title mt-3 mt-lg-0">
            {{ $filters.translate('T_CONNECT_WITH_US') }}
          </h5>
          <div id="footerIconNum" data-footericon="4" data-footerpadicon="3" class="row icon-container">
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.facebook.com/HongKongBaptistUniversity" title="Facebook">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-FB.svg">
                  <img lazyload="" src="@/assets/footer/social-FB.svg" alt="Facebook" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://instagram.com/hkbaptistu/" title="Instagram">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-IG.svg">
                  <img lazyload="" src="@/assets/footer/social-IG.svg" alt="Instagram" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.linkedin.com/school/hong-kong-baptist-university/" title="Linkedin">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-IN.svg">
                  <img lazyload="" src="@/assets/footer/social-IN.svg" alt="Linkedin" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.youtube.com/hongkongbaptistu" title="Youtube">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-YT.svg">
                  <img lazyload="" src="@/assets/footer/social-YT.svg" alt="Youtube" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://twitter.com/hkbaptistu" title="Twitter">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-twitter-x.svg">
                  <img lazyload="" src="@/assets/footer/social-twitter-x.svg" alt="Twitter" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="http://www.weibo.com/hongkongbaptistuniv" title="Weibo">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-Weibo.svg">
                  <img lazyload="" src="@/assets/footer/social-Weibo.svg" alt="Weibo" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.hkbu.edu.hk/content/dam/hongkongbaptistuniversity/hkbu-assets/doc/20220921_wechat.pdf" title="WeChat">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-Wechat.svg">
                  <img lazyload="" src="@/assets/footer/social-Wechat.svg" alt="WeChat" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.zhihu.com/org/xiang-gang-jin-hui-da-xue-69" title="Zhihu">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-Zhihu-2.svg">
                  <img lazyload="" src="@/assets/footer/social-Zhihu-2.svg" alt="Zhihu" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.hkbu.edu.hk/content/dam/hongkongbaptistuniversity/hkbu-assets/doc/20230425_weixin_channel.pdf" title="Weixin Channel">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-wx-channel.svg">
                  <img lazyload="" src="@/assets/footer/social-wx-channel.svg" alt="Weixin Channel" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.xiaohongshu.com/user/profile/640eebc80000000010029f55" title="Xiaohongshu">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-xiaohongshu.svg">
                  <img lazyload="" src="@/assets/footer/social-xiaohongshu.svg" alt="Xiaohongshu" class="mx-auto">
                </picture>
              </a>
            </div>
            <div class="col-3 footer--connect-icon mb-3 social-icon-4">
              <a target="_blank" href="https://www.toutiao.com/c/user/token/MS4wLjABAAAA2N98xyyCucLoVwiijE7BeWs1GTfTNXkF6HjALyjQecY/" title="Toutiao">
                <picture>
                  <source media="(max-width: 767px)" srcset="@/assets/footer/social-toutiao.svg">
                  <img lazyload="" src="@/assets/footer/social-toutiao.svg" alt="Toutiao" class="mx-auto">
                </picture>
              </a>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <a href="https://www.hkbu.edu.hk/en/subscription.html" class="c-button c-button__text footer--subscribe-button">
                <span>
                  {{ $filters.translate('T_SUBSCRIBE') }}
                </span>
                <i class="far fa-paper-plane" />
              </a>
            </div>
          </div>
          <div class="ueo-footer-copyright">
            {{ $filters.translate('T_COPYRIGHT') }}
          </div>
        </div>
      </div>

      <div class="footer-container footer--bottom-section row">
        <div class="col-md-5 col-sm-12 footer-logo-section">
          <a href="https://www.hkbu.edu.hk/">
            <img lazyload="" src="@/assets/footer/footer-logo.svg" alt="footer-logo" class="footer-logo"></a>
        </div>
        <div class="col-md-7 col-sm-12 footer-link-section footer--smaller-text">
          <div>
            <a href="https://www.hkbu.edu.hk/en/sitemap.html" class="footer-link">
              {{ $filters.translate('T_SITEMAP') }}
            </a>
            <span class="footer-link-separator">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a href="https://www.hkbu.edu.hk/en/accessibility.html" class="footer-link">
              {{ $filters.translate('T_ACCESSIBILITY') }}
            </a>
            <span class="footer-link-separator">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a href="https://www.hkbu.edu.hk/en/disclaimer.html" class="footer-link">
              {{ $filters.translate('T_DISCLAIMER') }}
            </a>
            <span class="footer-link-separator">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a href="https://policies.hkbu.edu.hk/" target="_blank" class="footer-link">
              {{ $filters.translate('T_UNIVERSITY_POLICIES') }}
            </a>
            <span class="footer-link-separator">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a href="https://bupdpo.hkbu.edu.hk/policies-and-procedures/pps-pics/" target="_blank" class="footer-link">
              {{ $filters.translate('T_PRIVACY_POLICY') }}
            </a>
          </div>
          <div class="footer-copyright">
            {{ $filters.translate('T_COPYRIGHT') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "./MainFooter.scss";

</style>
